import { createSelector } from '@reduxjs/toolkit'
import { QueryStatus } from '@reduxjs/toolkit/query'

import api from '../api'

const getCurrentUserQuerySelector = api.endpoints.getCurrentUser.select()

export const isCurrentUserQueryLoadedSelector = createSelector(
  [getCurrentUserQuerySelector],
  (getCurrentUserQuery) => getCurrentUserQuery.status === QueryStatus.fulfilled
)

export const isCurrentUserQueryRejectedSelector = createSelector(
  [getCurrentUserQuerySelector],
  (getCurrentUserQuery) => getCurrentUserQuery.status === QueryStatus.rejected
)
